export default {
    namespaced: true,
    state: {
        snackbarText: "",
        snackbar: false,
        colorType: "success",
        timeout: 3000,
    },
    getters: {},
    mutations: {
        OPEN_SNACKBAR(state, options) {
            state.snackbar = true
            state.snackbarText = options.snackbarText
            state.colorType = options.colorType
        },
        CLOSE_SNACKBAR(state) {
            state.snackbar = false
        },
    },
    actions: {
        openSnackbar (context,options){
            let timeout = context.state.timeout
            context.commit('OPEN_SNACKBAR',{
                snackbarText: options.snackbarText,
                colorType: options.colorType
            })
            setTimeout(()=>{
                context.commit('CLOSE_SNACKBAR')
            },timeout)
        }
    },
  }
  